import apiClient from "../apiClient";
import { CommonApiResponse } from "../../Controllers/Types/ApiResponse";
import { baseURL } from "../ApiConstant";

// get item list
export const getFSItemList = async (category: 'Light' | 'Bathroom') => {
    try {
        const formData = new FormData();
        formData.append("category", category);

        const response = await apiClient.post(`/api/fs-item-list`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        console.error("Error fetching data:", error);

        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};